import { render, staticRenderFns } from "./WcpMobile.vue?vue&type=template&id=66ce53a6"
import script from "./WcpMobile.vue?vue&type=script&lang=js"
export * from "./WcpMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports